module.exports = __webpack_public_path__ + "static/media/duplicate.862f1050.svg";